export const BINDER_TEMPLATE_QUERY_WRITE_QUERY = 'BINDER_TEMPLATE_QUERY_WRITE_QUERY';
export const BINDER_TEMPLATE_QUERY_WRITE_NODE = 'BINDER_TEMPLATE_QUERY_WRITE_NODE';
export const BINDER_TEMPLATE_QUERY_WRITE_VALUESET = 'BINDER_TEMPLATE_QUERY_WRITE_VALUESET';
export const BINDER_TEMPLATE_QUERY_ADD_CHILD_NODE = 'BINDER_TEMPLATE_QUERY_ADD_CHILD_NODE';
export const BINDER_TEMPLATE_QUERY_REMOVE_CHILD_NODE = 'BINDER_TEMPLATE_QUERY_REMOVE_CHILD_NODE';
export const BINDER_TEMPLATE_QUERY_REMOVE_ALL_CHILD_NODES = 'BINDER_TEMPLATE_QUERY_REMOVE_ALL_CHILD_NODES';
export const BINDER_TEMPLATE_QUERY_WRAP_IN_NEW_PARENT = 'BINDER_TEMPLATE_QUERY_WRAP_IN_NEW_PARENT';
export const BINDER_TEMPLATE_QUERY_WRITE_QUERIES = 'BINDER_TEMPLATE_QUERY_WRITE_QUERIES';
export const BINDER_TEMPLATE_QUERY_WRITE_SELECTED_QUERY_ID = 'BINDER_TEMPLATE_QUERY_WRITE_SELECTED_QUERY_ID';
export const BINDER_TEMPLATE_QUERY_WRITE_REMOVE_DOCUMENT_TYPE_FROM_QUERY = 'BINDER_TEMPLATE_QUERY_WRITE_REMOVE_DOCUMENT_TYPE_FROM_QUERY';
export const BINDER_TEMPLATE_QUERY_WRITE_REMOVE_QUERY = 'BINDER_TEMPLATE_QUERY_WRITE_REMOVE_QUERY';
export const BINDER_TEMPLATE_QUERY_CHANGE_DISPLAY_ORDER = 'BINDER_TEMPLATE_QUERY_CHANGE_DISPLAY_ORDER';
export const BINDER_TEMPLATE_QUERY_WRITE_OPTION_VALUE = 'BINDER_TEMPLATE_QUERY_WRITE_OPTION_VALUE';
export const BINDER_TEMPLATE_QUERY_MANIPULATE_OPTION = 'BINDER_TEMPLATE_QUERY_MANIPULATE_OPTION';
export const BINDER_TEMPLATE_REMOVE_QUERIES = 'BINDER_TEMPLATE_REMOVE_QUERIES';

export function writeQuery(queryId, data) {
    return {
        type: BINDER_TEMPLATE_QUERY_WRITE_QUERY,
        payload: {
            id: queryId,
            data: data
        }
    };
}

export function writeNode(nodeId, data) {
    return {
        type: BINDER_TEMPLATE_QUERY_WRITE_NODE,
        payload: {
            id: nodeId,
            data: data
        }
    };
}

export function writeValueSet(valueSetId, data) {
    return {
        type: BINDER_TEMPLATE_QUERY_WRITE_VALUESET,
        payload: {
            id: valueSetId,
            data: data
        }
    };
}

export function addChildNode(parentId, newNodeId, data, placementNodeId, placementMethod) {
    return {
        type: BINDER_TEMPLATE_QUERY_ADD_CHILD_NODE,
        payload: {
            parentId: parentId,
            nodeId: newNodeId,
            data: data,
            placementNodeId: placementNodeId,
            placementMethod: placementMethod
        }
    };
}

export function removeNodeFromParent(parentId, childId) {
    return {
        type: BINDER_TEMPLATE_QUERY_REMOVE_CHILD_NODE,
        payload: {
            parentId,
            childId
        }
    };
}

export function removeAllChildNodes(parentId) {
    return {
        type: BINDER_TEMPLATE_QUERY_REMOVE_ALL_CHILD_NODES,
        payload: {
            parentId: parentId,
        }
    };
}

export function wrapInNewParent(parentId, childId, newNodeId, data) {
    return {
        type: BINDER_TEMPLATE_QUERY_WRAP_IN_NEW_PARENT,
        payload: {
            parentId: parentId,
            childId: childId,
            nodeId: newNodeId,
            data: data,
        }
    };
}

export function writeBinderTemplateQueries(binderTemplateId, queries) {
    return {
        type: BINDER_TEMPLATE_QUERY_WRITE_QUERIES,
        payload: {
            binderTemplateId,
            queries
        }
    };
}

export function writeSelectedQueryId(selectedQueryId) {
    return {
        type: BINDER_TEMPLATE_QUERY_WRITE_SELECTED_QUERY_ID,
        payload: selectedQueryId
    };
}

export function writeRemoveDocumentTypeFromQuery(queryId, documentTypeId) {
    return {
        type: BINDER_TEMPLATE_QUERY_WRITE_REMOVE_DOCUMENT_TYPE_FROM_QUERY,
        payload: {
            queryId: queryId,
            documentTypeId: documentTypeId
        }
    };
}

export function writeRemoveChildQuery(queryId) {
    return {
        type: BINDER_TEMPLATE_QUERY_WRITE_REMOVE_QUERY,
        payload: queryId
    };
}

export function moveUpDisplayOrder(queryId) {
    return {
        type: BINDER_TEMPLATE_QUERY_CHANGE_DISPLAY_ORDER,
        payload: {
            queryId,
            relative: 'up',
        }
    };
}

export function moveDownDisplayOrder(queryId) {
    return {
        type: BINDER_TEMPLATE_QUERY_CHANGE_DISPLAY_ORDER,
        payload: {
            queryId,
            relative: 'down',
        }
    };
}

export function writeQueryOptionValue(queryId, optionsKey, propertyName, keyIndex, value) {
    return {
        type: BINDER_TEMPLATE_QUERY_WRITE_OPTION_VALUE,
        payload: {
            queryId,
            optionsKey,
            propertyName,
            keyIndex,
            value
        }
    };
}

export function writeQueryOptionManipulation(queryId, optionsKey, keyIndex, actionName) {
    return {
        type: BINDER_TEMPLATE_QUERY_MANIPULATE_OPTION,
        payload: {
            queryId,
            optionsKey,
            keyIndex,
            actionName
        }
    };
}

export function removeQueries() {
    return {
        type: BINDER_TEMPLATE_REMOVE_QUERIES,
    };
}
